/* Progressive enhancement for the native fallback navigation. Dawn owns commerce interactions. */
document.addEventListener('toggle', (event) => {
  if (event.target.matches('.sn-mobile-nav')) event.target.querySelector('summary').setAttribute('aria-expanded', String(event.target.open));
}, true);
document.addEventListener('click', (event) => {
  document.querySelectorAll('.sn-mobile-nav[open]').forEach((menu) => {
    if (!menu.contains(event.target) || event.target.closest('a')) menu.removeAttribute('open');
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.sn-mobile-nav[open]').forEach((menu) => {
    menu.removeAttribute('open');
    menu.querySelector('summary').focus();
  });
});

/* A solid header after leaving the top ensures navigation stays legible. */
(() => {
  let header;
  let ticking = false;
  const update = () => {
    ticking = false;
    if (!header) return;
    header.classList.toggle('sn-header-solid', window.scrollY > 12);
  };
  const connect = () => {
    header = document.querySelector('.section-header');
    update();
  };
  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }, { passive: true });
  document.addEventListener('shopify:section:load', connect);
  window.addEventListener('pageshow', connect);
  connect();
})();
